// Mecanismo de tradução PT/ES, leve (sem biblioteca externa) — o idioma escolhido
// pelo usuário na tela de Login fica em useInterfaceStore.language (persistido em
// localStorage) e vale para o app inteiro, incluindo antes do login.
import { useInterfaceStore } from '../stores/useInterfaceStore';
import { translations } from './translations';

export function useT() {
  const language = useInterfaceStore((state) => state.language);
  return (key: string, params?: Record<string, string | number>): string => {
    let text = translations[language][key] ?? translations.pt[key] ?? key;
    if (params) {
      for (const [paramKey, value] of Object.entries(params)) {
        text = text.replace(new RegExp(`{{${paramKey}}}`, 'g'), String(value));
      }
    }
    return text;
  };
}

// Locale do Intl/toLocaleDateString conforme o idioma ativo (ex.: formatação de datas/moeda).
export function useLocale(): string {
  const language = useInterfaceStore((state) => state.language);
  return language === 'es' ? 'es-ES' : 'pt-BR';
}
